export default "<div class=\"sx-modal-overlay modal-lote\">\r\n    <div class=\"modal-content\">\r\n        {{{ card }}}\r\n    </div>\r\n</div>\r\n"